import { useCallback, useRef, useState } from "react";

const SUBMIT = "submit";

const useRecaptcha = (recaptchaSiteKey) => {
  const [token, setToken] = useState(null);
  const scriptRef = useRef(null);

  const generateRecaptchaToken = useCallback(async () => {
    if (!recaptchaSiteKey) {
      setToken(null);
      return;
    }

    const token = await window.grecaptcha.execute(recaptchaSiteKey, {
      action: SUBMIT,
    });

    setToken(token);
  }, [recaptchaSiteKey]);

  const loadGoogleRecaptcha = useCallback(async () => {
    await new Promise((resolve) => {
      scriptRef.current = document.createElement("script");
      scriptRef.current.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`;
      scriptRef.current.onload = resolve;
      document.body.appendChild(scriptRef.current);
    });
  });

  const cleanupScript = useCallback(() => {
    const badgeElement = document.querySelector(".grecaptcha-badge");

    if (badgeElement) {
      badgeElement.remove();
    }
  }, []);

  return { token, loadGoogleRecaptcha, generateRecaptchaToken, cleanupScript };
};

export default useRecaptcha;
